import {
  SET_WAITING_PATIENT,
  SET_ATTENDED_PATIENT,
  SET_REFERRAL_PATIENT,
  SET_CONSULTANT_PATIENT,
  SET_ADMITTED_PATIENT,
  SET_OBSERVATION_PATIENT,
  SET_EMERGENCY_PATIENT,
  SET_CURRENT_PATIENT_TYPE,
  SET_TOTAL_WAITING_PATIENT,
  SET_TOTAL_ATTENDED_PATIENT,
  SET_TOTAL_REFERRAL_PATIENT,
  SET_TOTAL_CONSULTANT_PATIENT,
  SET_TOTAL_ADMITTED_PATIENT,
  SET_TOTAL_OBSERVATION_PATIENT,
  SET_TOTAL_EMERGENCY_PATIENT,
  SET_PATIENT_MR_AND_VISITID,
  SET_ADMITTED_PATIENT_MR_AND_VISITID,
  SET_NURSE_PATIENT_MR_AND_VISITID,
  SET_NURSE_ADMITTED_PATIENT_MR_AND_VISITID,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  setWaitingPatient: [],
  setAttendedPatient: [],
  setReferralPatient: [],
  setConsultantPatient: [],
  setAdmittedPatient: [],
  setObservationPatient: [],
  setEmergencyPatient: [],
  setCurrentPatientType: 1,
  setTotalWaitingPatient: {
    TWP: 0,
    TAP: 0,
    TRP: 0,
    TCP: 0,
    TOP: 0,
    TAMP: 0,
    TEP: 0,
    WPL: [],
    APL: [],
    RPL: [],
    CPL: [],
    OPL: [],
    AMPL: [],
    EPL: [],
  },
  setTotalAttendedPatient: 0,
  setTotalReferralPatient: 0,
  setTotalConsultantPatient: 0,
  setTotalAdmittedPatient: 0,
  setTotalObservationPatient: 0,
  setTotalEmergencyPatient: 0,
  setPatientDetails: {
    MrNumber: undefined,
    VisitID: undefined,
  },
  setAdmittedPatientDetails: {
    MrNumber: undefined,
    VisitID: undefined,
  },
  setNursePatientDetails: {
    MrNumber: undefined,
    VisitID: undefined,
  },
  setNurseAdmittedPatientDetails: {
    MrNumber: undefined,
    VisitID: undefined,
  },

  dataLoaded: false,
};

const DrDashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_WAITING_PATIENT: {
      return {
        ...state,
        setWaitingPatient: action.payload,
      };
    }
    case SET_ATTENDED_PATIENT: {
      return {
        ...state,
        setAttendedPatient: action.payload,
      };
    }
    case SET_REFERRAL_PATIENT: {
      return {
        ...state,
        setReferralPatient: action.payload,
      };
    }
    case SET_CONSULTANT_PATIENT: {
      return {
        ...state,
        setConsultantPatient: action.payload,
      };
    }
    case SET_ADMITTED_PATIENT: {
      return {
        ...state,
        setAdmittedPatient: action.payload,
      };
    }
    case SET_OBSERVATION_PATIENT: {
      return {
        ...state,
        setObservationPatient: action.payload,
      };
    }
    case SET_EMERGENCY_PATIENT: {
      return {
        ...state,
        setEmergencyPatient: action.payload,
      };
    }
    case SET_TOTAL_WAITING_PATIENT: {
      return {
        ...state,
        setTotalWaitingPatient: action.payload,
      };
    }
    case SET_TOTAL_ATTENDED_PATIENT: {
      return {
        ...state,
        setTotalAttendedPatient: action.payload,
      };
    }
    case SET_TOTAL_REFERRAL_PATIENT: {
      return {
        ...state,
        setTotalReferralPatient: action.payload,
      };
    }
    case SET_TOTAL_CONSULTANT_PATIENT: {
      return {
        ...state,
        setTotalConsultantPatient: action.payload,
      };
    }
    case SET_TOTAL_ADMITTED_PATIENT: {
      return {
        ...state,
        setTotalAdmittedPatient: action.payload,
      };
    }
    case SET_TOTAL_OBSERVATION_PATIENT: {
      return {
        ...state,
        setTotalObservationPatient: action.payload,
      };
    }
    case SET_TOTAL_EMERGENCY_PATIENT: {
      return {
        ...state,
        setTotalEmergencyPatient: action.payload,
      };
    }
    case SET_CURRENT_PATIENT_TYPE: {
      return {
        ...state,
        setCurrentPatientType: action.payload,
      };
    }
    case SET_PATIENT_MR_AND_VISITID: {
      return {
        ...state,
        setPatientDetails: action.payload,
        dataLoaded: true,
      };
    }
    case SET_ADMITTED_PATIENT_MR_AND_VISITID: {
      return {
        ...state,
        setAdmittedPatientDetails: action.payload,
        dataLoaded: true,
      };
    }
    case SET_NURSE_PATIENT_MR_AND_VISITID: {
      return {
        ...state,
        setNursePatientDetails: action.payload,
        dataLoaded: true,
      };
    }
    case SET_NURSE_ADMITTED_PATIENT_MR_AND_VISITID: {
      return {
        ...state,
        setNurseAdmittedPatientDetails: action.payload,
        dataLoaded: true,
      };
    }

    default:
      return state;
  }
};

export default DrDashboard;
